<template>
    <HeroSection :featureName="baseFeature.name" :icon="baseFeature.icon">
        <template #title>{{ baseFeature.description  }}</template>
        <template #description>
            <div>Add floorplans to your event app to help attendees navigate and explore your event spaces.</div>
            <div class="mt-4">Provide a basic floorplan, and then optinoally map booths, rooms and points of interest. For the full experience, add navigation and wayfinding to your floorplans.</div>
        </template>
        <template #content>
            <CmsAndApp :webImage="webImage" :appImage="appImage" />
        </template>
    </HeroSection>

    <Tips :title="baseFeature.name" :tips="tips" />
    <WorksWith :title="baseFeature.name" :integrations="integrations" v-if="false" />
    <Cta />
</template>

<script setup>
import Cta from '../../components/Blocks/Cta.vue';
import HeroSection from '../../components/HeroSection.vue';
import CmsAndApp from '../../components/Layouts/CmsAndApp.vue';
import Tips from '../../components/Blocks/Tips.vue';
import WorksWith from '../../components/Blocks/WorksWith.vue';
import { getFeaturesByIds } from '../../router/features';

import appImage from '@/images/screenshots/app/theme-1/floorplans.png';
import webImage from '@/images/screenshots/cms/floorplan-mapping.png';

const tips = [
    'Mapping booths and rooms will enable a "Show on Map" option within Sessions and Exhibitor Profiles.',
    'Add Points of Interest, such as Registration Desks or phone charging stations, which will help your attendees find their way around the event.',
];

const baseFeature = getFeaturesByIds(['interactivefloorplans'])[0];
const integrations = getFeaturesByIds(['badgesandkiosks', 'companyportals', 'eventapp']);
</script>
